import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import { Trophy, ArrowRight, Sparkles } from "lucide-react";

export default function OnePercentClubTeaser() {
  const navigate = useNavigate();
  const location = useLocation();

  const goToClubPage = () => {
    navigate("/1-percent-community-club");
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 50);
  };

  const handleLearnMore = (e) => {
    e.stopPropagation();
    goToClubPage();
  };

  const handleUnlockPremium = (e) => {
    e.stopPropagation();
    if (location.pathname !== "/") {
      navigate("/?highlight=premium");
    } else {
      const el = document.getElementById("premium-package");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
      window.dispatchEvent(new CustomEvent("highlight-premium-package"));
    }
  };

  return (
    <section
      id="one-percent-club"
      data-testid="section-one-percent-teaser"
      className="py-14 sm:py-16 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          role="button"
          tabIndex={0}
          data-testid="opc-teaser-card"
          onClick={goToClubPage}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              goToClubPage();
            }
          }}
          whileHover={{ scale: 1.01 }}
          transition={{ type: "spring", stiffness: 200, damping: 20 }}
          className="group relative rounded-[2.5rem] overflow-hidden border border-[#06B6D4]/30 bg-gradient-to-br from-[#0F172A] via-[#1E3A8A] to-[#0F172A] hairline cursor-pointer hover:border-[#06B6D4]/70 hover:shadow-[0_30px_90px_-20px_rgba(6,182,212,0.45)] transition-all duration-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#06B6D4]/70"
        >
          <div className="absolute inset-0 gradient-mesh opacity-30 pointer-events-none" />
          <div className="absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-[#06B6D4]/20 blur-3xl pointer-events-none transition-opacity duration-500 group-hover:opacity-90" />
          <div className="absolute top-0 left-1/2 -translate-x-1/2 h-px w-1/3 bg-gradient-to-r from-transparent via-[#06B6D4]/70 to-transparent" />

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.55 }}
            className="relative p-10 sm:p-14 lg:p-16 text-white"
          >
            <span
              data-testid="opc-teaser-badge"
              className="inline-flex items-center gap-2 rounded-full border border-[#06B6D4]/40 bg-[#06B6D4]/15 px-3 py-1.5 text-[10px] uppercase tracking-[0.24em] text-[#06B6D4] font-semibold"
            >
              <Sparkles className="h-3 w-3" /> Exclusive Premium Benefit
            </span>
            <div className="mt-5 inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] text-slate-300 font-semibold">
              <Trophy className="h-4 w-4 text-[#06B6D4]" />
              The 1% Community Club
            </div>
            <h2
              data-testid="opc-teaser-headline"
              className="font-display mt-3 text-2xl sm:text-3xl tracking-tight font-semibold text-white text-balance leading-snug max-w-3xl"
            >
              Where skills meet mentorship, community, and real execution.
            </h2>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={handleLearnMore}
                data-testid="opc-teaser-cta-learn-more"
                className="inline-flex justify-center items-center gap-2 rounded-full bg-white text-[#0F172A] px-6 py-3.5 text-sm font-semibold hover:-translate-y-0.5 hover:shadow-[0_10px_30px_-10px_rgba(255,255,255,0.4)] transition-all duration-300"
              >
                Learn More About 1% Community Club <ArrowRight className="h-4 w-4" />
              </button>
              <button
                type="button"
                onClick={handleUnlockPremium}
                data-testid="opc-teaser-cta-premium"
                className="inline-flex justify-center items-center gap-2 rounded-full border border-white/20 text-white px-6 py-3.5 text-sm font-medium hover:bg-white/5 hover:border-[#06B6D4]/60 hover:-translate-y-0.5 transition-all duration-300"
              >
                Unlock Premium Package
              </button>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
